const stateKeys = {
  dismissBudgetControl: 'dismissBudgetControl'
}

export const state = () => ({
  dismissBudgetControl: false,
  hasEnergySaving: false,
  energySavingDetails: null
})

export const mutations = {
  setDismissBudgetControl(state, data) {
    state.dismissBudgetControl = data
  },
  setSettings(state, data) {
    state.energySavingDetails = data
  },
  setSettingsValue(state, { key, value }) {
    if (state.energySavingDetails) {
      state.energySavingDetails[key] = value
    }
  },
  setHasEnergySaving(state, value) {
    state.hasEnergySaving = value
  }
}

export const actions = {
  clearStorage({ dispatch }) {
    for (const prop in stateKeys) {
      this.$storage.removeUniversal(stateKeys[prop])
    }
    dispatch('clearSettings')
  },
  clearSettings({ commit }) {
    commit('setSettings', null)
    commit('setHasEnergySaving', false)
  },
  getDismissBudgetControl() {
    return this.$storage.getUniversal(stateKeys.dismissBudgetControl)
  },
  setDismissBudgetControl({ commit }, value) {
    commit('setDismissBudgetControl', value)
    this.$storage.setUniversal(stateKeys.dismissBudgetControl, value)
  },
  async getBudgetControlSettings({ commit }) {
    const data = await this.$apiAaltra.settingsBudgetControl()

    if (!data) return

    const hasEnergySaving = !!(data && data.gatewayId && data.houseId)
    commit('setHasEnergySaving', hasEnergySaving)

    data.emitterType = data.emitterType || 'Unknown'

    commit('setSettings', data)

    return data
  },

  async deactivateEnergySaving({ dispatch }) {
    await dispatch('clearStorage')
    await this.$apiAaltra.deleteOnectaToken()
  },

  async saveData(_, { data }) {
    const relevantData = {
      enabledDate: this.$dateTimeToEpoch(new Date()) * 1000
    }
    if (data.authenticationCode) {
      relevantData.authenticationCode = data.authenticationCode
    }
    if (data.hasPermissionBudgetControl) {
      relevantData.hasPermissionBudgetControl = data.hasPermissionBudgetControl
      relevantData.userMode = data.userMode
      relevantData.emitterType = data.emitterType
    }
    await this.$apiAaltra.updateSettingsEnergySaving(relevantData)
  }
}
